// language=GraphQL
export const ALL_PACKAGES_QUERY = `query Query($withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
  packages: ratioFamilyPackages {
    id
    ratioServiceNo
    accommodation @include(if: $withAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    name
    label
    info
    capacitySettings @include(if: $withCapacitySettings) {
      id
      totalCapacity
      rangesAllowed
      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
        id
        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        minCapacity
        maxCapacity
      }
      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
        id
        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        capacity
      }
      partialOccupancyAllowed
      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
    addons @include(if: $withAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_PACKAGE_QUERY = `query Query($id: ID!, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
  package: ratioFamilyPackage(id: $id) {
    id
    ratioServiceNo
    accommodation @include(if: $withAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
    name
    label
    info
    capacitySettings @include(if: $withCapacitySettings) {
      id
      totalCapacity
      rangesAllowed
      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
        id
        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        minCapacity
        maxCapacity
      }
      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
        id
        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        capacity
      }
      partialOccupancyAllowed
      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
    }
    addons @include(if: $withAddons) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withAddonsCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withAddonsMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withAddonsMandatorySettingsRules) {
          id
          checkAccommodationTypes
          checkAccommodationAddons
          checkAgeGroups
          useAgeFilter
          checkDateRange
          startDate
          endDate
          checkTravelDate
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_PACKAGE_MUTATION = `
  mutation Mutation($input: CreateRatioFamilyPackageInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
    package: createRatioFamilyPackage(input: $input) {
      id
      ratioServiceNo
      accommodation @include(if: $withAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
          id
          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
          id
          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_PACKAGE_MUTATION = `
  mutation Mutation($input: UpdateRatioFamilyPackageInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false, $withAddonsMandatorySettingsDateSwitchSettings: Boolean = false, $withAddonsMandatorySettingsBusSettings: Boolean = false) {
    package: updateRatioFamilyPackage(input: $input) {
      id
      ratioServiceNo
      accommodation @include(if: $withAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
      name
      label
      info
      capacitySettings @include(if: $withCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {
          id
          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {
          id
          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          rules @include(if: $withAddonsMandatorySettingsRules) {
            id
            checkAccommodationTypes
            checkAccommodationAddons
            checkAgeGroups
            useAgeFilter
            checkDateRange
            startDate
            endDate
            checkTravelDate
          }
          useDateSwitch
          dateSwitchSettings @include(if: $withAddonsMandatorySettingsDateSwitchSettings) {
            id
            startDateOffsetDays
            endDateOffsetDays
          }
          useBusSettings
          busSettings @include(if: $withAddonsMandatorySettingsBusSettings) {
            id
            boardingSelectionEnabled
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_PACKAGE_MUTATION = `
  mutation Mutation($input: DeleteRatioFamilyPackageInput) {
    deleteRatioFamilyPackage(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PACKAGE_MUTATION = `
  mutation Mutation($input: DeleteRatioFamilyPackageInput) {
    forceDeleteRatioFamilyPackage(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_PACKAGE_ADDONS_MUTATION = `
  mutation Mutation($input: addRatioFamilyPackageAddonsInput) {
    addRatioFamilyPackageAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const REMOVE_PACKAGE_ADDONS_MUTATION = `
  mutation Mutation($input: removeRatioFamilyPackageAddonsInput) {
    removeRatioFamilyPackageAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const CREATE_PACKAGE_ADDONS_MUTATION = `
  mutation Mutation($input: createRatioFamilyPackageAddonsInput) {
    createRatioFamilyPackageAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const DELETE_PACKAGE_ADDONS_MUTATION = `
  mutation Mutation($input: deleteRatioFamilyPackageAddonsInput) {
    deleteRatioFamilyPackageAddons(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const UPDATE_PACKAGE_ADDONS_ORDER_MUTATION = `
  mutation Mutation($input: updateRatioFamilyPackageAddonsOrderInput) {
    updateRatioFamilyPackageAddonsOrder(input: $input) {
      id
      addonIds
    }
  }`

// language=GraphQL
export const PACKAGES_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravellers: Boolean = false, $withRatioTravels: Boolean = false, $withTravelPricingRules: Boolean = false) {
  groupedDependents: ratioFamilyPackageDependents(id: $id) {
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus
      suppressBusBoardingSelection    }
    travelPricingRules @include(if: $withTravelPricingRules) {
      id
      checkAccommodationTypes
      checkAccommodationAddons
      checkAgeGroups
      useAgeFilter
      checkDateRange
      startDate
      endDate
      checkTravelDate
    }
  }
}`
